import { useContext } from "react";
import AllComponentsWrapper from "./all-components-wrapper.component";
import { languageChangerObject } from "./language";
import { LanguageContext } from './contexts/language.context'
function App() {
	const { romanianLanguage } = useContext(LanguageContext);
	// const [romanianLanguage, setRomanianLanguage] = useState(false);
	const { russian, romanian } = languageChangerObject;
	console.log("romanianLanguage", romanianLanguage)
	return (
		<div className="App" style={{ backgroundColor: "#FBFAFE" }}>
			{<AllComponentsWrapper props={romanianLanguage ? romanian : russian} lang={romanianLanguage ? "ro" : "ru"} />}

		</div>
	);
}

export default App;
